import axios from './axios';

const getCertificateBySubmissionId = (submissionId: string | undefined) =>
  axios.get(`/certificates/certificate-by-submission-id/${submissionId}`);

const getCertificateFile = (submissionId: string | undefined) =>
  axios.get(`/certificates/certificate-file-by-submission-id/${submissionId}`, { responseType: 'arraybuffer' });

export default { getCertificateBySubmissionId, getCertificateFile };
